export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
export const cell = (n) => (n ? Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 }) : "–");

export const monthLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleString("en-IN", { month: "short", year: "numeric" });
};

export const fyMonths = (fy) => {
  if (!fy) return [];
  const start = parseInt(fy.replace("FY", "").trim().split("-")[0], 10);
  return [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3].map(m => `${m < 4 ? start + 1 : start}-${String(m).padStart(2, "0")}`);
};

export const currentFy = () => {
  const d = new Date();
  const s = d.getMonth() + 1 >= 4 ? d.getFullYear() : d.getFullYear() - 1;
  return `FY ${s}-${String((s + 1) % 100).padStart(2, "0")}`;
};

export const fyOptions = () => {
  const s = parseInt(currentFy().slice(3, 7), 10);
  return [s - 2, s - 1, s, s + 1].map(y => `FY ${y}-${String((y + 1) % 100).padStart(2, "0")}`);
};
